import { SalesLead } from "kinnect-models";
import {
	KAddressFormBox,
	KForm,
	KPhoneField,
	KTextField,
	KTextarea
} from "kinnect-general";

export default KForm.extend( {
	name: "SalesLeadForm",

	props: {
		redirect: {
			...KForm.options.props.redirect,
			default: () => [ "back", { name: "salesLeads" } ]
		},

		salesLead: SalesLead
	},

	data: () => ( {
		formFields: {
			companyName: null,
			contactName: null,
			projectAddress: null,
			projectCity: null,
			projectState: null,
			projectZip: null,
			projectLat: null,
			projectLng: null,
			phone: null,
			email: null,
			notes: null
		}
	} ),

	computed: {
		editing() {
			return Boolean( this.salesLead );
		},

		formUrl() {
			return this.editing
				? `sales/sales-leads/${this.salesLead.id}`
				: "sales/sales-leads";
		}
	},

	watch: {
		salesLead: {
			handler( salesLead ) {
				if ( salesLead ) {
					Object.keys( this.formFields ).forEach( key => {
						if ( salesLead.hasOwnProperty( key ) ) {
							this.formFields[key] = salesLead[key];
						}
					} );
				}
			},
			immediate: true
		}
	},

	render() {
		return <KForm
			attrs={{
				...this.$props,
				action: this.formUrl,
				data: this.formFields,
				method: this.editing ? "put" : "post"
			}}
			on={this.$listeners}
		>
			<KTextField
				label="Company Name*"
				prependIcon="business"
				required
				vModel={this.formFields.companyName}
				validationId="companyName"
				validationName="company name"
				validationRules="required"
			></KTextField>

			<KTextField
				label="Contact Name"
				prependIcon="contacts"
				vModel={this.formFields.contactName}
				validationId="contactName"
				validationName="contact name"
			></KTextField>

			<KAddressFormBox
				address={this.formFields.projectAddress}
				addressLabel="Project Address"
				city={this.formFields.projectCity}
				cityLabel="Project City"
				class="mb-4 ml-blank-icon"
				lat={this.formFields.projectLat}
				lng={this.formFields.projectLng}
				on={{
					"update:address": val => this.formFields.projectAddress = val,
					"update:city": val => this.formFields.projectCity = val,
					"update:lat": val => this.formFields.projectLat = val,
					"update:lng": val => this.formFields.projectLng = val,
					"update:state": val => this.formFields.projectState = val,
					"update:zip": val => this.formFields.projectZip = val
				}}
				state={this.formFields.projectState}
				stateLabel="Project State"
				zip={this.formFields.projectZip}
				zipLabel="Project Zip"
			></KAddressFormBox>

			<KPhoneField
				label="Phone Number"
				vModel={this.formFields.phone}
				validationName="phone"
				validationRules="phone"
			></KPhoneField>

			<KTextField
				label="Email"
				prependIcon="email"
				type="email"
				vModel={this.formFields.email}
				validationName="email"
				validationRules="email"
			></KTextField>

			<KTextarea
				label="Notes"
				prependIcon="comment"
				vModel={this.formFields.notes}
				validationName="notes"
			></KTextarea>
		</KForm>;
	}
} );
